import React from 'react';
import "../assets/team.css"
import { LazyLoadImage } from "react-lazy-load-image-component";

import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
export default function Team() {
    return (
        <div className='team-element'>
            <div className='team-hero'>
                <Navbar/>
                <div className='container texty'>
                <h1>Our Team</h1>
                <p>"United by a common purpose, our diverse team thrives on collaboration, creativity, and unwavering determination. Together, we conquer challenges, transform ideas into reality, and achieve greatness. With passion in our hearts and a shared vision in our minds, we are unstoppable in our pursuit of excellence."</p>
                </div>
            </div>
            <div className="image-section">
                <div className="container">
                    <div className="row text-center">
                        <div className="col text-center">
                            <LazyLoadImage className="img img-box mx-auto my-4" src={require("../assets/sagar_president.png")} alt="" />
                        </div>
                        <div className="col text-center">
                            <LazyLoadImage className="img img-box mx-auto my-4" src={require("../assets/shivani_vicepresident.png")} alt="" />
                        </div>
                        <div className="col text-center">
                            <LazyLoadImage className="img img-box mx-auto my-4" src={require("../assets/dummy.png")} alt="" />
                        </div>
                    </div>
                    <div className="row text-center">
                        <div className="col text-center">
                            <LazyLoadImage className="img img-box mx-auto my-4" src={require("../assets/shashwat_membersecretary.png")} alt="" />
                        </div>
                        <div className="col text-center">
                            <LazyLoadImage className="img img-box mx-auto my-4" src={require("../assets/gauri_membersecretary.png")} alt="" />
                        </div>
                        <div className="col text-center">
                            <LazyLoadImage className="img img-box mx-auto my-4" src={require("../assets/khyati_treasurer.png")} alt="" />
                        </div>
                    </div>
                </div>
            </div>
            <Footer></Footer>
        </div>
    );
}
